import { TICKS_PER_SECOND } from '../sim/constants';

/**
 * זמן משחק כ-`דקות:שניות`.
 *
 * חי כאן ולא ברכיב כי שני מסכים מציגים אותו — התפריט ("המשך משחק") ומסך הסיום —
 * ושתי נוסחאות לאותו מספר הן שני מספרים שונים ברגע שמישהו נוגע באחת מהן.
 */
export function formatGameTime(tick: number): string {
    const seconds = Math.floor(tick / TICKS_PER_SECOND);
    const minutes = Math.floor(seconds / 60);
    return `${minutes}:${String(seconds % 60).padStart(2, '0')}`;
}
